const PRODUCTION = process.env.NODE_ENV === 'production';

const API_URL_DEV = process.env.REACT_APP_API_URL_DEV;

export const AUTH_TOKEN_KEY = 'auth_token';
export const AGORA_APP_ID = '12934dd56c904bada036f4e00867a7b3';

export const DEFAULT_PAGE_SIZE = 10;

export const isTelegram = PRODUCTION ? 1 : 0;

export const config = {
  API_BASE_URL: PRODUCTION ? 'https://api.mytadating.site' : API_URL_DEV,
  API_URL: PRODUCTION ? 'https://api.mytadating.site/api' : `${API_URL_DEV}/api`,
  DEFAULT_USER_ID: '67fba439cf98acec362a6a2f', // Current user's ID
  FALLBACK_AVATAR: '/images/default-avatar.png',
  // Temporary: блокировка покупок (игровая валюта + подписка). false — вернуть как было.
  PURCHASES_FROZEN: false,
  BYN_PAYMENT_FROZEN: true,
  BYN_PAYMENT_FROZEN_MESSAGE: 'Оплата временно недоступна. Попробуйте позже',
  PURCHASES_FROZEN_MESSAGE: 'Функционал временно недоступен. Попробуйте позже',
  MESSAGE_STATUS: {
    READ: 'read',
    DELIVERED: 'delivered'
  },
  API: {
    ACCEPTANCE: {
      DOCUMENTS: '/acceptance/documents',
      DOCUMENT: (type) => `/acceptance/document?type=${type}`,
      ACCEPT: (id) => `/acceptance/accept/${id}`
    },
    TRIALS: {
      CHECK: '/trials/check',
      INFO: '/trials/info',
      USE: '/trials/use'
    },
    AUTH: {
      LOGIN: '/auth/login',
      REGISTER: '/auth/register',
      REFRESH: '/auth/refresh',
      LOGOUT: '/auth/logout'
    },
    USERS: {
      ME: '/users/me',
      ACTIVITY: '/users/activity',
      BASE: '/users',
      PROFILE: '/users/profile',
      BY_ID: (id) => `/users/${id}`,
      MAIN_INFO_UPDATE: '/users/mainInfoUpdate',
      UPDATE_AUDIO: '/users/updateAudio',
      UPDATE_PHOTOS: '/users/updatePhotos',
      UPDATE_INTERESTS: '/users/updateInterests',
      UPDATE_MEET_GOAL: '/users/updateMeetGoal',
      UPDATE_LOCATION: '/users/updateLocation',
      DELETE_PHOTO: '/users/photo',
      UPDATE_FILTERS: '/users/updateFilters',
      DELETE_ACCOUNT: '/users/delete',
      CHECK_PHOTOS: '/users/check/photos',
      INSTRUCTION_STATUS: '/users/instruction/status',
      INSTRUCTION_MARK: '/users/instruction/mark',
      CHECK_BLOCK: (id) => `/chats/check-block/${id}`,
      BLOCK_BY_ID: (id) => `/chats/block/${id}`,
      UNBLOCK_BY_ID: (id) => `/chats/unblock/${id}`,
      REPORT: `/report`,
      REFERRAL_LINK: '/referrals/link'
    },
    MEDIA: {
      BASE: '/media',
      UPLOAD: '/media/upload',
      DELETE: (id) => `/media/${id}`,
      GET: (id) => `/media/${id}`
    },
    CHATS: {
      BASE: '/chats',
      DELETED: (id) => `/chats/${id}`,
      CREATE: (id) => `/chats/${id}`,
      HISTORY: (id) => `/chats/${id}/history`,
      MESSAGES: (id) => `/chats/${id}/messages`,
      MARK_READ: (id) => `/chats/${id}/read`,
      TYPING: (id) => `/chats/${id}/typing`,
      FIND_BY_USERNAME: (name) => `/chats/${name}/find-by-name`
    },
    WALLET: {
      BASE: '/wallet',
      BALANCE: '/wallet/balance',
      TRANSACTIONS: '/wallet/transactions',
      DEPOSIT: '/wallet/deposit',
      WITHDRAW: '/wallet/withdraw',
      PURCHASE: '/wallet/purchase'
    },
    PRODUCTS: {
      ALL: '/products'
    },
    LIMITS: {
      MY: '/limits/my'
    },
    MATCHES: {
      BASE: '/matches',
      POTENTIAL: '/matches/potential',
      CREATE: '/matches/create',
      LIKE: '/matches/like',
      SUPERLIKE: '/matches/superlike',
      RETURN: '/matches/return',
      LIST: '/matches/list',
      BY_ID: (id) => `/matches/${id}`,
      LIMITS: '/matches/limits',
      DELETED: (id) => `/notifications/${id}`
    },
    STREAMS: {
      BASE: '/streams',
      START: '/streams/start',
      MY: '/streams/my',
      BY_ID: (id) => `/streams/${id}`,
      JOIN: (id) => `/streams/${id}/join`,
      LEAVE: (id) => `/streams/${id}/leave`,
      CHAT: (id) => `/streams/${id}/chat`,
      GIFT: (id) => `/streams/${id}/gift`,
      REPORT: (id) => `/streams/${id}/report`,
      BAN: (id) => `/streams/${id}/ban`
    },
    MODERATION: {
      BASE: '/moderation',
      REPORTS: '/moderation/reports',
      ACTIONS: '/moderation/actions',
      BAN: (id) => `/moderation/ban/${id}`,
      UNBAN: (id) => `/moderation/unban/${id}`
    },
    NOTIFICATIONS: {
      BASE: '/notifications',
      LIST: '/notifications',
      COUNTS: '/notifications/counts',
      MARK_READ: (id) => `/notifications/read/${id}`,
      MARK_ALL_READ: '/notifications/read-all',
      DELETE: (id) => `/notifications/${id}`
    },
    SUPPORT: {
      BASE: '/support',
      CREATE_TICKET: '/support',
      MY_TICKETS: '/support/my',
      TICKET_BY_ID: (id) => `/support/my/${id}`,
      ADD_MESSAGE: (id) => `/support/my/${id}/messages`
    },
    SUBSCRIPTION: {
      ACTIVE: '/subscription/my',
      HISTORY: '/subscription/my/history',
      CANCEL: '/subscription/my/cancel',
      RESUME: '/subscription/my/resume'
    },
    PAYMENT: {
      LIST: '/payment/my',
      CREATE_ORDER: (productId) => `/payment/create-order/${productId}`,
      CREATE_INVOICE: (productId) => `/payment/create-invoice/${productId}`,
      CREATE_BIND_CARD: '/payment/create-bind-card',
      UNBIND_CARD: (paymentId) => `/payment/unbind-card/${paymentId}`
    }
  },
  ROUTES: {
    HOME: '/',
    MEET: '/meet',
    MENU: '/menu',
    CALCULATE: '/calculatepage',
    MATCH: '/match',
    FILTERS: '/filters',
    ROULETTE: '/roulette',
    ROULETTE_INSTRUCTION: '/roulette/instruction',
    SUBSCRIPTION: {
      MAIN: '/subscription'
    },
    STREAMS: {
      LIST: '/streams',
      WATCH: (id) => `/streams/watch/${id}`,
      FILTERS: '/streams/filters',
      STREAMER: '/streamer',
      STREAMER_PROFILE: (id) => `/streamer/profile/${id}`,
      BROADCASTER: '/broadcaster'
    },
    CHATS: {
      LIST: '/chats',
      PROFILE: (id) => `/chats/profile/${id}`,
      TEXT: (chat_id) => `/chats/${chat_id}`,
      VIDEO: '/chats/video/:id'
    },
    PROFILE: {
      VIEW: '/profile/:id',
      EDIT: '/profileedit',
      PHOTO: '/profileedit/photo',
      MAIN: '/profileedit/main',
      MEET_GOAL: '/profileedit/meetGoal',
      AUDIO: '/profileedit/audio',
      INTERESTS: '/profileedit/interests',
      DELETE: '/profileedit/delete',
      CONFIRM_DELETE: '/profileedit/confirmdelete'
    },
    MATCHS: {
      SUPER_LIKE_PROFILE_ID: (id, notificationId) => `/super-like/${id}/${notificationId}`
    },
    REACTION: '/reaction/:id',
    NOTIFICATIONS: '/notifications',
    PROFILE_MENU: '/profilemenu',
    INVITE: '/invite',
    SUPPORT: '/support',
    MYTA_IDEA: '/mytaidea',
    PAYMENT: '/makepayment',
    PREMIUM: '/premium',
    PREMIUM_TRIAL: (trialId) => `/premium/trial/${trialId}`,
    BAN: '/ban'
  },
  // WebSocket URL - без /socket.io, path указывается отдельно в socket.io клиенте
  WS_URL: 'https://api.mytadating.site'
};

export default config;
